import { useFind } from 'api/APIHooks';

export const useEnrollmentReviewReasonOptions = (planId) => {
  const { data: reviewReasons } = useFind(
    'enrollment_review_reasons',
    {
      plan: planId,
    },
    {
      queryConfig: {
        placeholderData: undefined,
        enabled: !!planId,
      },
    },
  );

  return reviewReasons?.data?.data?.map((reviewReason) => ({
    label: reviewReason?.reason,
    value: reviewReason?.id,
  }));
};
